module.exports = __webpack_public_path__ + "static/BeaconDA-Bold-c36614a6ddd3cc6e12f63e1e13ec3dec.otf";